// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import Modal from '../../_common/Modal';
import Card from '../Card';
import Cart, { itemTypes } from '../../_common/Cart';
import Col from '../../_common/form/Col';
import { currency, generateId } from '../../_common/api/utility';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Button from '../../_common/form/Button';
import Select from '../../_common/form/Select';
import { Regex } from '../../_common/api/regex';
import Input from '../../_common/form/Input';
import Form from '../../_common/form/Form';
import { HamQuest } from '../../../App';

const GiftCards = ({ ...props }) => {
    const {
        state: {
            active_user,
            site_config
        },
    } = useGlobalState();

    const [giftCards, setGiftCards] = useState([]);
    const [filter, setFilter] = useState(itemTypes.giftCard);

    useEffect(() => {
        HamQuest.get(QuestRoute.products.giftCards)
            .then((res) => {
                setGiftCards(res)
            })
            .catch(ex => {
                Modal.Show({
                    type: 'error',
                    title: 'Unable to get Gift Cards',
                    body: 'Sorry, something went wrong. Please try again.'
                })
            })
    }, [])

    const checkBalance = () => {
        Modal.Show({
            title: 'Check Balance',
            body: <Form
                inputs={{
                    cardNumber: '',
                }}
                onSubmit={(e) =>
                    HamQuest.getQuery(QuestRoute.giftCard.balance, {
                        cardNumber: e.cardNumber
                    })
                        .then(res => Modal.Show({
                            title: site_config.cardName + ' Balance',
                            body: (
                                <Col>
                                    {res.responseMessage && <div>Status: {res.responseMessage}</div>}
                                    <div>Balance: {currency.format(res.balance ?? 0)}</div>
                                </Col>
                            )
                        }))
                }
                submitButton='Check'
            >
                <Input
                    label='Check Gift Card Balance'
                    name='cardNumber'
                    mask={Regex.mask.creditCard}
                    sanitize={Regex.match.notNumbers}
                    maxLength={19}
                    validate={Regex.test.creditCard}
                    required
                />
            </Form>
        })
    }

    return (
        <Col>
            <Card icon='creditCard' title={site_config.cardName}>
                <Button onClick={checkBalance}>Check Gift Card Balance</Button>
                <Select
                    standalone
                    label={'Buy or Reload'}
                    onChange={e => setFilter(e.target.value)}
                    value={filter}
                    options={[
                        {
                            label: 'Buy New',
                            value: itemTypes.giftCard
                        },
                        {
                            label: 'Reload',
                            value: itemTypes.recharge
                        },
                    ]}
                />
            </Card>

            {giftCards
                .filter(e => e.productType === filter)
                .sort((a, b) => b.price - a.price)
                .map((e, i) => (
                    <Card key={`${i}-itemCard`} title={e.name}>
                        <span>Price: ${e.price}</span>
                        {e.value && <span>You get a value of: ${e.value}</span>}
                        {e.details?.map(e => <p key={generateId()}>{e}</p>)}
                        {active_user.isLoggedIn &&
                            <>
                                {/* {Cart.GiftButton(e)} */}
                                <Button onClick={() => Cart.BuyNow(e)}>{filter === itemTypes.recharge ? 'Reload!' : 'Buy Now!'}</Button>
                            </>
                        }
                    </Card>
                ))
            }
        </Col>
    );
}

export default GiftCards;